import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import ProposalForm from '../proposal_form/ProposalForm';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import { generateBackLink } from '../../utils/HistoryUtils';
import { updateNavbarState } from '../../actions/navbar_actions';
import { Form } from '@ant-design/compatible';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import { getQuoteSubURL, getQuoteRestCrudThunksContractorId } from '../quote_utils/QuoteUtils';

const queryString = require('qs');

class EditQuoteSubcontractorPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			backLinkText: 'Back To Quote ' + props.match.params.id,
		};
	}
	componentDidMount() {
		const { getQuote, match, updateNavbar, userType, location, currentUser } = this.props;
		const quoteId = match.params.id;
		getQuote(quoteId).then((quote) => {
			let searchString = location.search;
			if (searchString[0] === '?') {
				searchString = searchString.slice(1);
			}
			const path = getQuoteSubURL(userType, currentUser, quote);
			updateNavbar(
				'Back to Quote ' + match.params.id,
				generateBackLink(`/${path}/detail/` + match.params.id + '/details', location)
			);
			const queryParams = queryString.parse(searchString);
			if (queryParams.backlinkParams) {
				this.setState({
					loading: false,
					backLinkTo:
						`/${path}/detail/` + match.params.id + `/details?${queryParams.backlinkParams}`,
				});
			} else {
				this.setState({
					loading: false,
					backLinkTo: `/${path}/detail/` + match.params.id + `/details`,
				});
			}
		});
	}

	render() {
		const { history, location, quote, fetching, match, userType, currentUser, companyConfig } =
			this.props;

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		//noinspection TypeScriptUnresolvedVariable
		const path = getQuoteSubURL(userType, currentUser, quote);
		return [
			<DetailPageHeader
				exactPath={`/${path}/edit/:id`}
				backLinkText={this.state.backLinkText || 'Back to Quote'}
				backLinkTo={this.state.backLinkTo}
				title={'Edit Quote ' + match.params.id}
				tabs={[]}
				backgroundColor={nullSafeGet('config.theme.navblock', companyConfig)}
			/>,
			<EditPage
				title={`Edit Quote ${quote.id}`}
				formComponentProps={{
					formData: { ...quote, workOrderId: nullSafeGet('workOrder.id', quote) },
					onSuccess: (rec) => {
						if (!!queryParams.btwo) {
							history.push(`/${userType}/workOrders/detail/${rec.workOrderId}/quotes`);
						} else {
							history.push(`/${path}/detail/${rec.id}`);
						}
					},
				}}
				fetching={fetching}
				FormComponent={ProposalForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		location: ownProps.location,
		history: ownProps.history,
		quote: getEntityById(ownProps.match.params.id, state.proposals),
		fetching: state.proposals.fetching,
		match: ownProps.match,
		currentUser: state.session.currentUser,
		companyConfig: state.company_config.detail,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getQuote: (id) =>
		dispatch(getQuoteRestCrudThunksContractorId(ownProps.userType, true, false).readOne(id)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditQuoteSubcontractorPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
